import { HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";

export abstract class CameraEventBase {
    abstract postLiveEvents(parking_lot_id: number, start:number, end: number): Observable<HttpResponse<Blob>>;
}